import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IntegrationSelectReducers } from '../app.reducers';

const getIntegrationSelectorState = createFeatureSelector<IntegrationSelectReducers.IntegrationSelectState>(IntegrationSelectReducers.TAG);

export const getLastIntegrationSelected = createSelector(getIntegrationSelectorState, (state) => state?.lastIntegrationSelected);

export const getData = createSelector(getIntegrationSelectorState, (state) => state?.data);
